import {SystemStatus} from "../../gd/const/system-status"

// const debug = "Views_convertStatusesToStatusString"
const debug = false

export default function Views_convertStatusesToStatusString(systemStatuses: SystemStatus[]) {
    const statusesDiff = _.difference(gd.const.systemStatus.ALL_STATUSES, systemStatuses)

    // convert statuses array into 'open', 'closed' or 'all' string
    let status
    if (!systemStatuses || systemStatuses.length===0) {
        // etot case dlya starih views gde nebilo etoi temi...
        status = 'open'
    } else {
        if (statusesDiff.length === 0) {
            status = 'all'
        } else if (statusesDiff.includes(SystemStatus.NOT_STARTED)) {
            status = 'closed'
        } else {
            status = 'open'
        }
    }

    debug && console.log(debug, 'process', status, statusesDiff, systemStatuses)

    return status
}